<template>
    <div id="redirect">
        <ruth-header :tickets="false"></ruth-header>
        <div id="container" class="nobackgroundimg">
            <div id="content">
                <h1 class="ticketsheading">Bad Hall</h1>
                <h2>"Ruth – das Familienmusical"<br>im Stadttheater Bad Hall</h2>
                <div v-if="soldOut || over">
                  <div class="content-box">
                    <span v-if="over">Die Aufführung im Stadttheater Bad Hall ist leider schon vorbei.</span>
                    <span v-if="soldOut">Die Aufführung im Stadttheater Bad Hall ist leider schon ausverkauft.</span>
                    <br>
                    Wenn ihr darüber informiert werden möchtet, wenn wir das nächste Mal in eurer Nähe sind, meldet euch hier zu unserem Newsletter an.
                  </div>
                  <div class="form" v-if="soldOut || over">
                      <form method="get" action="https://newsletter.kisi.org/">
                          <input type="hidden" name="step" value="2">
                          <input type="hidden" name="mode" value="ruth">
                          <div class="inputs">
                              <input type="email" required name="mail" placeholder="E-Mail-Adresse">
                              <div class="ticket-button">
                                  <input type="submit" value="Anmelden">
                                  <span class="glyphicon glyphicon-menu-right"></span>
                              </div>
                          </div>
                      </form>
                  </div>
                </div>
                <div v-if="!soldOut && !over">
                  <div class="content-box" >
                    Sie werden in Kürze zu oeticket weitergeleitet. Dort können Sie sich die gewünschten Karten kaufen.
                  </div>
                  <loader :display="true"></loader>
                </div>
            </div>
            <social-media></social-media>
            <ruth-footer></ruth-footer>
        </div>
    </div>
</template>

<script>
import ruthHeader from "../GlobalSegments/Header";
import socialMedia from "../GlobalSegments/SocialMedia";
import ruthFooter from "../GlobalSegments/Footer";
import loader from "../GlobalSegments/Loader";
import gtagjs from "vue-gtagjs";

export default {
  name: "RedirectBadHall",
  components: {
    ruthHeader,
    socialMedia,
    ruthFooter,
    loader
  },
  mounted() {
    if (!this.soldOut && !this.over) {
      // Wait for all views to be loaded
      this.$nextTick(() => {
        gtag("event", "page_view", {
          event_callback: () => {
            window.location.href =
              "https://www.oeticket.com/noapp/tickets.html?fun=evdetail&affiliate=H65&doc=evdetailb&key=1846649$11948971&utm_source=H65&utm_medium=dp&utm_campaign=kisigodssingingkids";
          }
        });
      });
    }
  },
  data: function() {
    return {
      soldOut: false,
      over: false
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/scss/var";

.content-box {
  text-align: center;
}

.links {
  text-align: center;

  a img {
    width: 300px;
  }

  a:not(:last-of-type) {
    margin-right: 20px;
  }
}

.form {
  text-align: center;
  margin: 16px;

  .inputs {
    display: flex;
    justify-content: center;
  }

  .ticket-button {
    margin-left: 12px;
    @include ticket_button;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Redirect/BadHall.vue